import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plane = defineConnector({
  identifier: "plane",
  name: "Plane",
  tagLine: "Open source project management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.plane\\.so/.*",
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your Plane API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Plane](https://app.plane.so/), go to your profile settings and generate an API key. See the [API docs](https://developers.plane.so/) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "plane_api_...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.plane.so/api/v1/users/me/",
  },
});
